import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const LOADING_GETONE_ENT_AJUSTES = 'LOADING_GETONE_ENT_AJUSTES';
export const PARAMS_ENT_AJUSTES = 'PARAMS_ENT_AJUSTES';

const initialState = {
  loadingGetOne: false,
  params: {},
};

export const entAjustesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETONE_ENT_AJUSTES:
      return {
        ...state,
        loadingGetOne: action.payload,
      };
    case PARAMS_ENT_AJUSTES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
